export function collectGroupIdsForSync({ baseGroupIds = [], recentGroupIds = [] }) {
  return [...new Set([...baseGroupIds, ...recentGroupIds].filter((id) => id > 0))];
}
